import React from 'react';
import { useHistory } from 'react-router-dom';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import { makeStyles } from '@material-ui/core/styles';
import { formatNumber } from './utils/formatDashboard';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    backgroundColor: theme.palette.warning.light,
    borderLeft: `4px solid ${theme.palette.warning.main}`,
  },
  actionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
    '&:last-child': { borderBottom: 'none' },
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '0.875rem',
  },
}));

const PendingActionsSection = ({ pendingActions, loading }) => {
  const classes = useStyles();
  const history = useHistory();

  const actions = pendingActions
    ? [
        { label: 'Agent Requests', count: pendingActions.pendingAgentRequests, link: '/agent-request' },
        { label: 'Tier Upgrades', count: pendingActions.pendingTierUpgrades, link: '/tier-request-upgrade' },
        { label: 'Personal Account Requests', count: pendingActions.pendingPersonalAccountRequests, link: '/agent-request' },
        { label: 'KYC', count: pendingActions.pendingKyc, link: '/kyc-list' },
      ]
    : [];

  const totalPending = pendingActions
    ? (pendingActions.pendingAgentRequests || 0) +
      (pendingActions.pendingTierUpgrades || 0) +
      (pendingActions.pendingPersonalAccountRequests || 0) +
      (pendingActions.pendingKyc || 0)
    : 0;

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardHeader
        title={
          <Box display="flex" alignItems="center">
            <WarningIcon style={{ marginRight: 8, color: '#ed6c02' }} />
            Pending Actions
          </Box>
        }
      >
        {totalPending > 0 && (
          <Chip label={formatNumber(totalPending)} color="warning" size="small" />
        )}
      </CmtCardHeader>
      <CmtCardContent>
        {loading ? (
          <Skeleton variant="text" height={40} />
        ) : (
          actions.map(({ label, count, link }) => (
            <div
              key={label}
              className={classes.actionRow}
              onClick={() => count > 0 && history.push(link)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && count > 0 && history.push(link)}
            >
              <Typography variant="body2">{label}</Typography>
              <Box display="flex" alignItems="center">
                <Chip
                  label={formatNumber(count)}
                  color={count > 0 ? 'secondary' : 'default'}
                  size="small"
                  style={{ marginRight: 8 }}
                />
                {count > 0 && (
                  <Typography className={classes.link} variant="body2">
                    View →
                  </Typography>
                )}
              </Box>
            </div>
          ))
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default PendingActionsSection;
